import { AWAIT_PLAY_QUEUE, CLEAR, INVALIDATE_PLAY_QUEUE, PLAYBACK_NOT_SUPPORTED, SET_BACKGROUND_IMAGE, SET_LYRICS, SET_MEDIA, SET_PLAY_QUEUE_DATA, SET_WEB_MEDIA, } from '../actions/Playback';
const initialState = {
    albumName: '',
    subTitle: '',
    subTitleContainerType: '',
    subTitleLink: undefined,
    durationSeconds: 0,
    logo: '',
    artistName: '',
    artwork: '',
    mediaId: '',
    title: '',
    button: {},
    contextMenu: {},
    onBackgroundImageRequired: [],
    hasLyrics: false,
    onLyricsRequired: [],
    onMediaViewed: [],
    onVisualPlayQueueDataRequired: [],
    onMiniTransportViewed: [],
    onPlaybackNotSupported: [],
    npvBackground: '',
    lyrics: undefined,
    playQueue: undefined,
    fetchingPlayQueue: false
};
const reducer = {
    [CLEAR]: (state, action) => initialState,
    [PLAYBACK_NOT_SUPPORTED]: (state, action) => initialState,
    [SET_MEDIA]: (state, action) => {
        return Object.assign(Object.assign(Object.assign({}, initialState), action.payload.metadata), { npvBackground: '' });
    },
    [SET_WEB_MEDIA]: (state, action) => {
        return Object.assign(Object.assign(Object.assign({}, state), action.payload.metadata), { onPlaybackNotSupported: action.payload.onPlaybackNotSupported });
    },
    [SET_BACKGROUND_IMAGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { npvBackground: action.payload.image });
    },
    [SET_LYRICS]: (state, action) => {
        return Object.assign(Object.assign({}, state), { lyrics: action.payload.lyrics });
    },
    [SET_PLAY_QUEUE_DATA]: (state, action) => {
        return Object.assign(Object.assign({}, state), { playQueue: action.payload.playQueueTemplate, fetchingPlayQueue: false });
    },
    [INVALIDATE_PLAY_QUEUE]: (state) => {
        return Object.assign(Object.assign({}, state), { playQueue: undefined });
    },
    [AWAIT_PLAY_QUEUE]: (state) => {
        return Object.assign(Object.assign({}, state), { fetchingPlayQueue: true });
    },
};
export function MediaReducer(state = initialState, action) {
    if (reducer[action.type]) {
        return reducer[action.type](state, action);
    }
    else {
        return state;
    }
}
